function asTrimmedString(value) {
    if (typeof value === "string") return value.trim();
    if (value == null) return "";
    return String(value).trim();
}

function toFiniteNumber(value) {
    const numeric = Number(value);
    return Number.isFinite(numeric) ? numeric : null;
}

function normalizePartyMember(member) {
    if (!member || typeof member !== "object") return null;

    const userId = asTrimmedString(member.userId || member._id);
    const nickname =
        asTrimmedString(member.nickname) ||
        asTrimmedString(member.name) ||
        "Player";
    const picture = asTrimmedString(member.picture) || null;

    if (!userId && nickname === "Player" && !picture) return null;

    return {
        userId: userId || null,
        nickname,
        picture,
    };
}

function findFriendForInvite(friends, message) {
    const list = Array.isArray(friends) ? friends : [];
    const steamId = asTrimmedString(message?.fromUserSteamId);
    const userId = asTrimmedString(message?.fromUserId);

    return (
        list.find((friend) => {
            const friendSteamId = asTrimmedString(friend?.friendSteamId);
            const friendUserId = asTrimmedString(friend?.friendData?.userId);
            return (
                (steamId && friendSteamId === steamId) ||
                (userId && friendUserId === userId)
            );
        }) || null
    );
}

export function formatInviteElo(value) {
    if (value == null || value === "") return null;
    const elo = toFiniteNumber(value);
    return elo == null ? null : Math.round(elo).toLocaleString("en-US");
}

export function formatPartyCountLabel(count, max = 5) {
    const size = Math.max(0, Math.floor(Number(count) || 0));
    const capacity = Math.max(size, Math.floor(Number(max) || 5));
    return `${size}/${capacity} players`;
}

export function buildInviteDataFromMessage(message, friends = []) {
    const event = message && typeof message === "object" ? message : {};
    const friend = findFriendForInvite(friends, event);
    const friendData = friend?.friendData || {};

    const fromUserName =
        asTrimmedString(event.fromUserName) ||
        asTrimmedString(friendData.nickname) ||
        "Player";
    const fromUserPicture =
        asTrimmedString(event.fromUserPicture) ||
        asTrimmedString(friendData.picture) ||
        null;
    const fromUserElo =
        toFiniteNumber(event.fromUserElo) ?? toFiniteNumber(friendData.elo);
    const fromUserRank =
        toFiniteNumber(event.fromUserRank) ??
        toFiniteNumber(friendData.globalRank) ??
        toFiniteNumber(friendData.rank);

    const payloadMembers = Array.isArray(event.partyMembers)
        ? event.partyMembers.map(normalizePartyMember).filter(Boolean)
        : [];
    const fallbackMember = normalizePartyMember({
        userId: event.fromUserId || friendData.userId,
        nickname: fromUserName,
        picture: fromUserPicture,
    });
    const partyMembers = payloadMembers.length
        ? payloadMembers
        : fallbackMember
          ? [fallbackMember]
          : [];

    return {
        inviteId: event.inviteId,
        fromUserId: event.fromUserId,
        fromUserSteamId: event.fromUserSteamId,
        fromUserName,
        fromUserPicture,
        fromUserElo,
        fromUserRank,
        partyMembers,
        partySize: toFiniteNumber(event.partySize) ?? partyMembers.length,
        timestamp: event.timestamp,
        expiresIn: event.expiresIn,
    };
}
